const MuiPopover = {
  styleOverrides: {
    root: {
      zIndex: '130000'
    }
  }
};
export default MuiPopover;